import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

const BooleanLabel = ({ bool }) => {
    return bool === true ? <CheckIcon/> : <CloseIcon/>
}

export default BooleanLabel